import classNames from "classnames";
import { FC, PropsWithChildren, useEffect, useRef } from "react";
import useOnClickOutside from "../../hooks/useOnclickOutside";
import SvgClose from "../icons/Close";
import Button from "./Button";
import styles from "./Sidebar.module.css";

type SidebarProps = PropsWithChildren<{
  title: string;
  onClose: () => void;
  isOpen?: boolean;
}>;

const Sidebar: FC<SidebarProps> = ({ title, children, onClose, isOpen }) => {
  const menuRef = useRef<HTMLDivElement>(null);

  useOnClickOutside(menuRef, () => isOpen && onClose());

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape" && isOpen) {
        onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  return (
    <div className={classNames(styles.sidebar, { [styles.sidebarOpen]: isOpen })} ref={menuRef}>
      <div className={styles.sidebarHeader}>
        <h2>{title}</h2>
        <Button type="secondary" buttonProps={{ onClick: onClose }} glyph={SvgClose} />
      </div>
      <div className={styles.sidebarContent}>{children}</div>
    </div>
  );
};

export default Sidebar;
